/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Watch_BodyInputs */

const en_features_watch_body = /** @type {(inputs: Features_Watch_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are building an Apple Watch app: your rest, the next set and the weight on your wrist, with your phone left in your bag.`)
};

const pl_features_watch_body = /** @type {(inputs: Features_Watch_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pracujemy nad aplikacją na Apple Watch: przerwa, następna seria i ciężar na zegarku, bez wyciągania telefonu.`)
};

/**
* | output |
* | --- |
* | "We are building an Apple Watch app: your rest, the next set and the weight on your wrist, with your phone left in your bag." |
*
* @param {Features_Watch_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_watch_body = /** @type {((inputs?: Features_Watch_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Watch_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_watch_body(inputs)
	return en_features_watch_body(inputs)
});